import { render, staticRenderFns } from "./CostOriginValueManage.vue?vue&type=template&id=bab55306&scoped=true&"
import script from "./CostOriginValueManage.vue?vue&type=script&lang=js&"
export * from "./CostOriginValueManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab55306",
  null
  
)

export default component.exports